import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    left: 0,
    height: 'auto',
    padding: '24px 32px',
    border: `1px solid ${theme.palette.secondary.light}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      background: 'white',
      padding: '8px 16px',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 24,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      gap: 0,
      width: '100%',
    },
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  illustration: {
    width: 40,
    height: 40,
  },
  content: {
    width: 530,
    lineHeight: '20px',
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  },
}))

export default useStyles
